/* Runs a report function when the user navigates away from the page,
 * such as when closing or switching tabs. Only sends a single report.
 *
 * Visiblity change is perferred method of determininng when session ends:
 * https://developer.chrome.com/articles/page-lifecycle-api/#legacy-lifecycle-apis-to-avoid
 */
function reportOnNavigateAway(report: () => void) {
  const listener = () => {
    if (document.visibilityState === 'hidden') {
      report();
      // Only report once
      document.removeEventListener('visibilitychange', listener);
    }
  };

  document.addEventListener('visibilitychange', listener);

  // Safari does not reliably fire the `visibilitychange` event
  // when the page is being unloaded, so we use pagehide

  document.addEventListener('pagehide', report);
}

export default reportOnNavigateAway;
